module.exports = __webpack_public_path__ + "img/money.d87a562f.svg";